import { useMutation } from "@tanstack/react-query";
import { markDiscursiveExerciseAsDone } from "../../queries/WeekSchedule";

interface IUseDoneDiscurviseExerciseProps {
  cronogramaId: string;
  exerciseId: string;
}

const useDoneDiscurviseExercise = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['done-discursive-exercise'],
    mutationFn: (params: IUseDoneDiscurviseExerciseProps) => markDiscursiveExerciseAsDone(params.cronogramaId, params.exerciseId),
    retry: false,
  });

  return { mutateAsync, isLoading: isPending };
};

export default useDoneDiscurviseExercise;